import React from 'react';
import SvgIcon from 'react-icons-kit';
import styled from 'styled-components';

const Button = styled.button`
    --size: 1.25em;
    align-items: center;
    background: rgb(245, 245, 245);
    border: none;
    border-radius: 50%;
    box-shadow: ${props => props.disabled ? 'none' : '0 0.25em 0.5em rgba(0, 0, 0, 0.5)'};
    display: flex;
    height: calc(var(--size) * 1.75);
    justify-content: center;
    transition: ease-in 150ms background-color;
    width: calc(var(--size) * 1.75);
    margin-left:0.4em;

    & svg {
        height: var(--size);
        width: var(--size);
        color: var(--color-data);
    }

    :disabled {
        cursor: not-allowed;
    }

    :hover {
        background-color: ${props => props.disabled ? 'rgb(245, 245, 245)' : 'white'};
    }
`;

const CircleButton = (props) => (
    <Button
        onClick={(e)=>props.action(e, props.variables)}
        disabled={props.disabled}
        name={props.name}
        title={props.title}
        value={props.variables}
    >
        <SvgIcon icon={props.icon} />
    </Button>
)
 
export default CircleButton;

CircleButton.defaultProps = {
    disabled: false,
    variables: ''
}